import * as yup from "yup";

const identityNumberValidation = yup
    .string()
    .required("validation.identity_number_required")
    .min(16, "validation.identity_number_min")
    .max(16, "validation.identity_number_max");

export default identityNumberValidation;
